import { DEFAULT_LABEL_SIZE } from "./sizes";
import { formatLabelDate, formatSourced } from "../format";
import type { LabelBuildOptions, LabelSizeId, SparePartLabelData } from "../types";
import { renderZplTemplate } from "./renderTemplate";
import template76x51 from "./templates/spare-part-76x51.zpl?raw";
import template100x50 from "./templates/spare-part-100x50.zpl?raw";
import template102x76 from "./templates/spare-part-102x76.zpl?raw";
import template56x25 from "./templates/spare-part-56x25.zpl?raw";

export const SPARE_PART_TEMPLATE_SIZES: readonly LabelSizeId[] = ["76x51", "56x25", "100x50", "102x76"] as const;

/** Placeholders used by spare-part-<size>.zpl — keep in sync with the template file. */
export const SPARE_PART_PLACEHOLDERS = [
  "partNameText",
  "partIdText",
  "sourcedCaption",
  "sourcedText",
  "harvestedCaption",
  "harvestedText",
  "qrValue",
] as const;

const TEMPLATES: Partial<Record<LabelSizeId, string>> = {
  "76x51": template76x51,
  "100x50": template100x50,
  "102x76": template102x76,
  "56x25": template56x25,
};

export function renderSparePartZpl(
  data: SparePartLabelData,
  size: LabelSizeId = DEFAULT_LABEL_SIZE,
  options: LabelBuildOptions = {},
): string {
  const template = options.zplTemplate ?? TEMPLATES[size] ?? TEMPLATES[DEFAULT_LABEL_SIZE]!;
  const sourcedText = formatSourced(data.sourceBrand, data.sourceModel);
  const harvestedText =
    data.harvestedDateFormatted ?? formatLabelDate(data.harvestedAt, options.locale);

  return renderZplTemplate(
    template,
    {
      partNameText: data.partName,
      partIdText: data.partId,
      sourcedCaption: data.captions?.sourced ?? "Sourced",
      sourcedText,
      harvestedCaption: data.captions?.harvested ?? "Harvested",
      harvestedText,
      qrValue: data.qrValue,
    },
    { allowedPlaceholders: SPARE_PART_PLACEHOLDERS },
  );
}
